import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-automationError',
  templateUrl: './automationError.component.html',
  styleUrls: ['./automationError.component.scss'] 
})

export class AutomationErrorComponent implements OnInit {

  errorStatement:string = '';
  title: "Error";

  constructor(private dialogRef: MatDialogRef<AutomationErrorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {      
    this.errorStatement= data.error; 
  }  
  
  ngOnInit(): void {
   
  }     

  close() {    
    this.dialogRef.close(false);
  }   
  
}
